import React from "react";

import { sqlDateToHumanDate, safeValue, getPropInSubLevelRole } from "../../utils/globalFunctions";
import LabelContentInline from "../../components/general/LabelContentInline";

const StockCategorySubData = ({ stateData }) => {
    return (
        <React.Fragment>
            <LabelContentInline
                stateColLabel={4}
                stateLabel='Sub Kategori'
                stateContent={stateData.stock_category_sub_name}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Kategori'
                stateContent={stateData.stock_category_name}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Stok Minimal'
                stateContent={stateData.stock_category_sub_stock_min}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Stok'
                stateContent={stateData.stock_actual}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Status'
                stateContent={stateData.stock_category_sub_is_active === '1' ? 'Aktif' : 'Non Aktif'}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Tanggal Input'
                stateContent={sqlDateToHumanDate({
                    stateDate: stateData.stock_category_sub_created_datetime,
                    stateWithTime: true,
                    stateLang: 'id',
                    stateIsShort: false,
                    stateDay: false,
                    stateDefaultValue: ' - ',
                    stateDateType: 'day'
                })}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Diinput Oleh'
                stateContent={safeValue(stateData.stock_category_sub_created_user_name, '-')}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Jabatan'
                stateContent={getPropInSubLevelRole(stateData.stock_category_sub_created_user_sub_level, 'caption', '-')}
                stateDivider={false}
            />
        </React.Fragment>
    )
}

export default StockCategorySubData;